import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  root: {
    margin: 'auto',
    maxWidth: '600px',
    padding: theme.spacing(2),
  },
  heading: {
    textAlign: 'center',
  },
  button: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '16px',
  },
  fieldSetStyle: {
    border: 'none',
    marginTop: '24px',
    padding: '0',
  },
});
